import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

class CustomSelect extends React.Component {

    render() {
			const {options, label, multiple, hidePlaceholderInMenu, canHaveZeroValue,
				placeholder, id, classes, meta, input:{onChange, value}} = this.props

			const val = canHaveZeroValue && value === 0 
				? 0 
				: value || (!multiple ? -1 : [])
      return (
				<FormControl
					fullWidth
					className={classes.selectFormControl}
					style={{paddingTop:'27px', marginBottom: '17px'}}
				>
					{label && <InputLabel htmlFor={id} className={classes.selectLabelMulti} >
          	{label}
        	</InputLabel>}
					<Select
						multiple={multiple}
						value={val}
						MenuProps={{ className: classes.selectMenu }}
						classes={{ select: classes.select }}
						inputProps={{
							onChange: onChange,
							id: id
						}}>
							{!hidePlaceholderInMenu && <MenuItem key={-1} value={-1} disabled>
								{placeholder}
							</MenuItem>}
							{options.map((item)=>(
								<MenuItem
									key={item.value}
									classes={{
										root: classes.selectMenuItem,
									}}
									value={item.value}
								>
									{item.label}
								</MenuItem>))
							}
					</Select>
					{meta.touched && meta.error &&
						<span style={{color: 'red', fontSize: '11px'}}>{meta.error}</span>}
				</FormControl>
      )  
    }
}

CustomSelect.propTypes = {
    options: PropTypes.array.isRequired,
		//placeholder: PropTypes.string.isRequired,
};

export default withStyles(styles)(CustomSelect)


// WEBPACK FOOTER //
// ./src/views/Components/CustomSelect.jsx